import { propertyQueryKeys as e } from "./usePropertiesQueryKeys.mjs";
import { runPropertyMediaUpload as t } from "./media/runPropertyMediaUpload.mjs";
import { useMutation as n, useQueryClient as r } from "@maat/store-hooks";
import { propertiesApi as i } from "@maat/api-main";
//#region src/properties/useUploadPropertyMediaMutation.ts
var a = () => {
	let a = r();
	return n({
		mutationFn: ({ propertyId: e, media: n, unitId: r, listingId: a, onUploadProgress: o }) => t({
			propertyId: e,
			groups: n.map(({ category: e, space_index: t, images: n }) => ({
				category: e,
				space_index: t,
				files: n
			})),
			presign: (t) => i.presignPropertyMedia(e, {
				media: t,
				unit_id: r || void 0,
				listing_id: a || void 0
			}),
			onUploadProgress: o
		}),
		onSuccess: (t, { propertyId: n }) => {
			a.invalidateQueries({ queryKey: e.images(n) }), a.invalidateQueries({ queryKey: e.property(n) }), a.invalidateQueries({ queryKey: e.hostFeed() });
		}
	});
};
//#endregion
export { a as useUploadPropertyMediaMutation };
